import React from 'react';
import { 
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

export const ASSIGNMENT_CATEGORIES = {
  ALL: 'All Assignments',
  INDIVIDUAL: 'Individual Assignments',
  FEEDBACK: 'Feedback Assignments'
};

const AssignmentCategoryFilter = ({ 
  selectedCategory = ASSIGNMENT_CATEGORIES.ALL, 
  onCategoryChange,
  sx = {},
  width = '200px'
}) => {
  const handleChange = (event) => {
    const category = event.target.value;
    onCategoryChange(category);
  };

  return (
    <FormControl sx={{ width, ...sx }}>
      <InputLabel 
        id="assignment-category-label"
        size="small"
        sx={{
          backgroundColor: 'white',
          px: 0.5,
          transform: 'translate(14px, -9px) scale(0.75)',
          '&.Mui-focused': {
            transform: 'translate(14px, -9px) scale(0.75)',
          },
          '&.MuiFormLabel-filled': {
            transform: 'translate(14px, -9px) scale(0.75)',
          }
        }}
      >
        Assignment Type
      </InputLabel>
      <Select
        labelId="assignment-category-label"
        label="Assignment Type"
        value={selectedCategory}
        onChange={handleChange}
        displayEmpty
        variant="outlined"
        size="small"
        sx={{
          backgroundColor: 'white',
          height: '40px',
          fontSize: '14px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E2E8F0',
            legend: {
              width: '0px !important'
            }
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2563eb',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2563eb',
          },
          '& .MuiSelect-select': {
            padding: '8px 14px',
          }
        }}
      >
        {Object.entries(ASSIGNMENT_CATEGORIES).map(([key, label]) => (
          <MenuItem 
            key={key} 
            value={label}
            sx={{
              fontWeight: 500,
              '&:hover': {
                backgroundColor: '#F8FAFC'
              }
            }}
          >
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AssignmentCategoryFilter;